import { post, get, put, del } from '@/utils/request'
import { storage } from '@/plugins/storage'


//解决方案列表
export const getJobPageList = async (data) => {
  return post({
    url: '/job/job/pageJobList',
    data,
  })
}

//查询城市列表
export const getCityList = async (data) => {
  return get({
    url: '/system/dict/data/dictType/job_city',
    data,
  })
}

//查询职业类别
export const getJobCategoryList = async (data) => {
  return get({
    url: '/system/dict/data/dictType/job_category',
    data,
  })
}

//人才列表详情
export const getJobDetail = async (data) => {
  return post({
    url: '/job/job/jobDetail',
    data,
  })
}

//获取产品类型
export const getProductTypeList = async (data) => {
  return post({
    url: '/customerProduct/product/getProductTypeList',
    data,
  })
}

//获取产品列表
export const getProductList = async (data) => {
  return post({
    url: '/customerProduct/product/getProductList',
    data,
  })
}

//获取产品详情
export const getProductInfo = async (data) => {
  return post({
    url: '/customerProduct/product/getProductInfo',
    data,
  })
}

//文件中心列表
export const getSalesFileCenterList = async (data) => {
  return post({
    url: '/sales/sales/getSalesList',
    data,
  })
}

//图片上传
export const uploadFile = async (data) => {
  return post({
    url: '/common/upload',
    data,
  })
}

//上传简历
export const addJobResume = async (data) => {
  return post({
    url: '/job/job/addJobResume',
    data,
  })
}

//查询文件中心文件
export const getSalesFileCenterListById = async (data) => {
  return post({
    url: '/sales/sales/getSalesFileCenterListById',
    data,
  })
}

//查询文件中心文件链接
export const getSalesFileCenterUrlListById = async (data) => {
  const token = storage.get('TOKEN')
  return post({
    url: '/sales/sales/getSalesFileCenterUrlListById',
    data,
    headers:{
      Authorization:"Bearer " + token
    }
  })
}

//查询问答中心列表
export const getSalesQaCenterListById = async (data) => {
  return post({
    url: '/sales/sales/getSalesQaCenterListById',
    data,
  })
}

//分页查询行业资讯
export const industryNewsPageList = async (data) => {
    return post({
        url: '/industry/pageList',
        data,
    })
}

//获取行业资讯详情
export const getIndustryNewsById = async (data) => {
    return post({
        url: '/industry/getById',
        data,
    })
}
